import { FEATURE_FLAG_KEYS } from '@/features/open-feature'
import { useLoadedFlagValue } from '@/utils/sharedHooks'

/**
 * Off renders today's signup and readiness code untouched; on renders the plan-list screens.
 * Null until the provider is ready and the visitor is targeted, so a caller must not treat it as off.
 */
export const useNewCatalogSignup = (): boolean | null => {
  const value = useLoadedFlagValue(FEATURE_FLAG_KEYS.newCatalogSignup, false)
  return value === null ? null : Boolean(value)
}
